var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMIconNavInventoriesGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 9.375H12.1875V10H9.6875V9.375ZM15 8.4375V13C15 14.1046 14.1046 15 13 15H2C0.89543 15 0 14.1046 0 13V8.4375C0 7.57562 0.700625 6.875 1.5625 6.875H3.125V1.5625C3.125 0.700625 3.82562 0 4.6875 0H10.3125C11.1744 0 11.875 0.700625 11.875 1.5625V6.875H13.4375C14.2994 6.875 15 7.57562 15 8.4375ZM3.75 6.875H11.25V1.5625C11.25 1.04562 10.8294 0.625 10.3125 0.625H4.6875C4.17062 0.625 3.75 1.04562 3.75 1.5625V6.875ZM0.625 13.375C0.625 13.9273 1.07272 14.375 1.625 14.375H6.1875C6.73978 14.375 7.1875 13.9273 7.1875 13.375V8.5C7.1875 7.94771 6.73978 7.5 6.1875 7.5H1.5625C1.04562 7.5 0.625 7.92062 0.625 8.4375V13.375ZM14.375 8.4375C14.375 7.92062 13.9544 7.5 13.4375 7.5H8.8125C8.26021 7.5 7.8125 7.94772 7.8125 8.5V13.375C7.8125 13.9273 8.26022 14.375 8.8125 14.375H13.375C13.9273 14.375 14.375 13.9273 14.375 13.375V8.4375ZM2.8125 9.375V10H5.3125V9.375H2.8125ZM6.25 3.125H8.75V2.5H6.25V3.125Z",
    fill: "url(#paint0_radial_671_84738)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_671_84738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7083 3.52041) rotate(-32.1344) scale(32.2291 17.1939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIconNavInventoriesGradient);
export default __webpack_public_path__ + "static/media/m-icon-nav-inventories-gradient.c77957d0235b5db6fc9361b91670cc65.svg";
export { ForwardRef as ReactComponent };